module.exports = __webpack_public_path__ + "static/media/interactive-audio.21085d29.svg";